<template>
  <view-resolver>
    <template v-slot:adminView>
      <base-nemsis-export
          :show-settings-page="true"
          :show-clients-filter="true"
          :use-impersonate="true"
      />
    </template>
    <template v-slot:clientView>
      <base-nemsis-export
          :show-settings-page="false"
          :show-clients-filter="false"
          :use-impersonate="false"
      />
    </template>
  </view-resolver>
</template>

<script>
import { SET_TITLE } from '@/store/mutations';
import ViewResolver from '@/components/ViewResolver';
import BaseNemsisExport from './BaseNemsisExport';

export default {

  components: {
    BaseNemsisExport,
    ViewResolver,
  },

  mounted() {
    this.$store.commit(SET_TITLE, 'NEMSIS/DHS Export');
  },
};
</script>
